import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import { Form } from 'antd';
import Translate from 'react-translate-component';

import {
    metroCell,
} from 'constants/dictionaries';
import { wrapCellFormItem } from 'constants/formItemLayout';
import { METRO_REQUEST_NEW } from 'constants/metro';
import { SelectLoadComponent } from 'components/common/form/Select';
import Input from 'components/common/form/Input';
import ListenerField from 'components/common/form/ListenerField';

export default class ApprovalFields extends Component {
    render() {
        const { cellId, departmentCode, oldPosition, isCNB, isACO } = this.props;

        return (
            <ListenerField listenFieldName={['displacedEmployee', 'requestType']}>
                { ({ requestType, displacedEmployee }) =>
                    requestType === METRO_REQUEST_NEW ? (
                        <Fragment>
                            <Form.Item wrapperCol={wrapCellFormItem}>
                                <Translate content='metro.request.positionNew' />
                            </Form.Item>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Field
                                name='cellId'
                                component={SelectLoadComponent}
                                label={{ content: 'metro.request.positionCurrent' }}
                                loadName={metroCell}
                                loadParams={{ DepartmentID: departmentCode }}
                                nameRender={option => (
                                    <span>
                                        {option.name} - <Translate
                                            content={`metro.request.position${option.is_vacant ? 'Vacant' : 'Placed'}`}
                                        />
                                    </span>
                                )}
                                disabled={true}
                            />
                            { oldPosition && (isCNB || isACO) && (
                                <Input
                                    input={{ value: oldPosition }}
                                    label={{ content: 'metro.request.positionCatalogNumber' }}
                                    disabled={true}
                                />
                            )}
                            { !!cellId && (
                                displacedEmployee ? (
                                    <Field
                                        name='displacedEmployee'
                                        component={Input}
                                        label={{ content: 'metro.request.displacedEmployee' }}
                                        disabled={true}
                                    />
                                ) : (
                                    <Fragment>
                                        <Form.Item wrapperCol={wrapCellFormItem}>
                                            <Translate content='metro.request.positionIsVacant' />
                                        </Form.Item>
                                    </Fragment>
                                )
                            )}
                        </Fragment>
                    )
                }
            </ListenerField>
        );
    }
}
